import StsA360RegStep1QuestionsModel
  from './sts-a360-reg-step1-questions.model';


export default class StsA360RegStep1AnswerModel {

  question: StsA360RegStep1QuestionsModel;
  answer: string;

}
